module.exports = __webpack_public_path__ + "img/taster_iam_header.d48f7747.png";